<template>
<div>
    <b-table 
        striped 
        hover 
        selectable 
        select-mode="single" 
        @row-selected="onRowSelected" 
        :items="items" 
        :fields="fields" 
        :filter="filter"
        @filtered="onFiltered"
        :per-page="perPage"
        :current-page="currentPage">
    </b-table>
    
    <TablePagination 
      :total-rows="totalRows" 
      :per-page="perPage" 
      @pageChange="onPageChange">
    </TablePagination>
</div>
</template>

<script>
import TablePagination from '@/components/Misc/TablePagination';
import daytype from '@/store/timetable/daytype';

export default {
    name: 'DayTypeTable',
    components: { TablePagination },
    props: ['filter'],
    data: function() {
        return {
            perPage: 10,
            currentPage: 1,
            filteredRows: 0
        }
    },
    computed: {
        fields() {
            return [
                { key: 'dayType.id', label: this.$t('day_types.id'), sortable: true },
                { key: 'dayType.finnishAbbreviation', label: this.$t('day_types.abbreviation'), sortable: true },
                { key: 'dayType.description', label: this.$t('day_types.description'), sortable: true },
                { key: 'dayType.days', label: this.$t('day_types.weekdays'), sortable: false, formatter: (value) => {
                    let days = '';
                    //if (!value.dayType) console.log('value.dayType is not defined');
                    if (value.monday) days += this.$t('weekdays.mon') +' ';
                    if (value.tuesday) days += this.$t('weekdays.tue') +' ';
                    if (value.wednesday) days += this.$t('weekdays.wed') +' ';
                    if (value.thursday) days += this.$t('weekdays.thu') +' ';
                    if (value.friday) days += this.$t('weekdays.fri') +' ';
                    if (value.saturday) days += this.$t('weekdays.sat') +' ';
                    if (value.sunday) days += this.$t('weekdays.sun') +' ';
                    return days;
                }}
            ];
        },
        items () {
            //return this.$store.state.daytype.dayTypeList;
            return this.$store.state.daytype.dayTypes;
        },
        totalRows() {
            return this.filteredRows ? this.filteredRows : (this.items ? this.items.length : 0);
        }
    },
    created() {
        if (!this.$store.state.daytype) {
            this.$store.registerModule('daytype', daytype);
        }
        //this.$store.dispatch('daytype/getDayTypeList');
        this.$store.dispatch('daytype/getDayTypesWithCalendars');
    },
    methods: {
        onRowSelected(items) {
            this.$emit('selectItem', items[0]);
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            this.currentPage = 1;
        },
        onPageChange(page) {
            this.currentPage = page;
        }
    }
}
</script>